var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaramel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_303699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#B1B6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9 318C416.7 333.2 416.7 357.9 431.9 373L500 441.1V500H0V206.7C14.4 213.5 32.1 210.9 44 199L243 0H359L500 141.1V250L431.9 318Z",
    fill: "#BAC2F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M250 447.5C321.963 447.5 380.3 423.413 380.3 393.7C380.3 363.987 321.963 339.9 250 339.9C178.037 339.9 119.7 363.987 119.7 393.7C119.7 423.413 178.037 447.5 250 447.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9 362.9C112.5 321.8 166.3 280.6 228.1 263C289.9 245.4 357.3 252.1 383.8 284.1C418.2 325.7 373.5 393.1 273.3 421.6C173 450.1 99.6 416.4 106.9 362.9Z",
    fill: "#A6A5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3 357.3C110.9 316.2 164.7 275 226.5 257.4C288.3 239.8 355.7 246.5 382.2 278.5C416.6 320.1 371.9 387.5 271.7 416C171.5 444.5 98 410.8 105.3 357.3Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.7 342.3C159.3 316.2 193.4 290.1 232.6 278.9C271.8 267.7 314.6 272 331.3 292.3C353.1 318.7 324.8 361.4 261.2 379.5C197.7 397.6 151.1 376.2 155.7 342.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 263.2C338 263.2 339.9 268.1 346.4 262.4C352.9 256.7 359.6 217.3 354.4 214.2C349.2 211.1 311.8 174.1 306.7 182.3C301.6 190.4 281.4 209.1 293.1 225C304.8 240.9 338 263.2 338 263.2Z",
    fill: "#CC5D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7 242.6C241.1 243.6 240.7 245.9 242 247.3C250.4 257 273.7 284.4 287.8 290.9C304.5 298.6 350.2 266.5 347.5 259.2C344.8 251.9 305.3 218.4 299.6 215.9C292 212.7 253.9 235.7 242.7 242.6Z",
    fill: "#B3520B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3 248.3C241.8 249.4 239.5 243.9 240.4 241.4C244 231.1 253 208.5 261.9 202C274.2 192.9 306.5 177.6 312.1 181.8C318.2 186.4 308.1 216.5 298.6 219.8C291.2 222.4 258 242.5 244.3 248.3Z",
    fill: "#D36316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4 378.2C194.4 378.2 192 381.9 199 383.6C206 385.3 236.1 371 235.7 366C235.4 360.9 242.6 317.7 234.7 318.1C226.7 318.5 204.3 313.7 199.1 329.3C193.8 344.8 194.4 378.2 194.4 378.2Z",
    fill: "#CC5D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8 303.3C161.3 302.7 159.6 303.5 159.2 305.1C156.5 315.5 149 344.5 151.4 357.2C154.1 372.3 197.9 388.1 201.6 382.8C205.2 377.5 209.3 334.5 208.2 329.4C206.8 322.6 172.9 307.6 162.8 303.3Z",
    fill: "#B3520B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6 307.1C157.7 305.9 160.3 301.7 162.5 301.1C171.2 298.6 191 294 199.7 296.9C211.8 300.9 237.7 315.6 237.5 321.5C237.2 327.8 211.9 335.3 205.1 330.5C199.8 326.7 170.2 313.7 159.6 307.1Z",
    fill: "#D36316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.2 423C344.4 411.2 368.3 392.8 386.4 370.3C423.9 323.7 426 265.9 407.9 210.7C404.7 200.9 400.7 190.6 396.6 181.2C344.5 62.8001 186.6 63.2001 110.6 158.1C90.4 182.8 76.7 212.5 69.4 243.5C69.3 244.1 68.6 244.5 68 244.4C67.4 244.3 67 243.6 67.1 243C72.7 210.9 85.1 179.8 104.4 153.3C164.1 69.1001 290 42.9001 373.2 108.7C401 130.5 419.9 159.5 432.5 192.2C459.7 259.1 459.8 332.6 415.1 392.2C394.2 420.1 366.7 443 335.5 458.5C325.3 464.1 312.2 459.7 307.7 448.9C303.5 438.8 308.2 427.2 318.2 423Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.4 128.8C160.6 138.6 130.3 164.4 139 185.4C147.7 206.4 184.7 203.1 208.4 193.2C228.1 185 245.3 172.2 243.8 154.1C271.8 145.9 306.7 133.5 334.1 122.1C387.3 100.1 427.6 75.5999 424.1 67.2999C420.7 58.9999 374.8 70.1999 321.7 92.1999C294.3 103.5 260.9 119.5 235.3 133.4C223.5 119.6 204.1 120.6 184.4 128.8Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 137.2C200.5 130.8 216.6 134.2 221.1 144.9C225.6 155.6 216.6 169.5 201.1 175.9C185.6 182.3 159 183.2 154.5 172.5C150.1 161.9 169.5 143.7 185 137.2Z",
    fill: "#D8D0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.8 142.8C175.1 144 158.2 155.3 158.2 155.3C158.2 155.3 148.7 171.9 159.5 179.9C170.3 187.9 188.6 202.2 185.8 221.4C183 240.5 172.6 273.2 182.2 280C191.8 286.8 197.7 281.6 198.9 276C200.1 270.4 196.2 243.3 195.7 237.7C195.2 232.1 193.8 187.5 200.1 180.7C206.4 173.9 219.6 167.1 216.8 157.2C214.1 147.1 191.4 141 181.8 142.8Z",
    fill: "#CC5D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.9 275.5C194.502 275.5 195.8 272.993 195.8 269.9C195.8 266.807 194.502 264.3 192.9 264.3C191.298 264.3 190 266.807 190 269.9C190 272.993 191.298 275.5 192.9 275.5Z",
    fill: "#E27023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.2 165.9C204.232 165.9 207.5 162.631 207.5 158.6C207.5 154.568 204.232 151.3 200.2 151.3C196.168 151.3 192.9 154.568 192.9 158.6C192.9 162.631 196.168 165.9 200.2 165.9Z",
    fill: "#E27023"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_303699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaramel);
export default __webpack_public_path__ + "static/media/Caramel.6fce772b.svg";
export { ForwardRef as ReactComponent };